/** Are we running in Storybook?
 * @see {@link isChromatic()} to specifically check for Chromatic snapshot tests */
export const isStorybook = "STORYBOOK" in import.meta.env;

/** Are we running under Vitest? (injected by Vitest, so in a real browser this means Browser Mode) */
export const isVitest = "VITEST_WORKER_ID" in import.meta.env;

/** Are we running in Storybook or Vitest? */
export const isTestEnvironment = import.meta.env.MODE === "test" || isStorybook;

/** Are we running in from built code (vs. from development server)? */
export const isBuiltRelease = import.meta.env.MODE === "production";

type Environment = "development" | "staging" | "production" | "test";

export function getEnvironment(): Environment {
    if (import.meta.env.DEV) {
        return "development";
    }

    const { hostname } = window.location;

    // Consider "localhost" and IP addresses as development (even when running the production build)
    if (hostname === "localhost" || /^[\d.]+$/.test(hostname)) {
        return "development";
    }

    if (import.meta.env.MODE === "production" && import.meta.env.DEV) {
        return "staging";
    }

    // Small hack to consider "test.pilw.io" as a staging environment (even though it uses the production build)
    if (hostname.endsWith(".pilw.io") && hostname.startsWith("test")) {
        return "staging";
    }

    return import.meta.env.MODE as Environment;
}
